/* eslint-disable */

import { useModal } from '../../hooks/use-modal-store'
import { post } from '../../http/restservice'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { messageModalState } from '../../store/Feedback'
import { usePaymentProcessingTimer } from '../../hooks/useProcessingTimer'
import { Progress } from '../../Components/ui/progress'

const POLL_INTERVAL = 10000 // 10 sec

const ActionPlanPaymentStatus = () => {
  const payData = useMemo(
    () => JSON.parse(localStorage.getItem('actionPlanPaymentStatusData')) || {},
    [],
  )

  const location = useLocation()
  let responseString = location?.state?.response ? location?.state?.response : payData.response
  const { onOpen } = useModal()
  const setMessageModalState = useSetRecoilState(messageModalState)
  const [timeElapsed, setTimeElapsed] = useState(0)
  const intervalRef = useRef(null)
  const { progress } = usePaymentProcessingTimer(300) // 2 minutes

  const paymentStatus = async (elapsed) => {
    try {
      const response = await post('/mutualfundservice/api/bseStar/mfUpload/paymentStatus', {
        clientCode: payData?.clientCode,
        orderNo: payData?.orderNo,
        isBasketOrder: true,
        customerBasketInvestmentIds: payData?.basketIds,
      })

      if (response.isError) {
        setMessageModalState({
          message: response?.response?.message || 'Something went wrong',
          severity: 'error',
        })
        return
      }

      const status = response?.data
      if (response?.status === 'SUCCESS') {
        if (status?.includes('AWAITING') && elapsed >= 30) {
          onOpen('openActionPlanPopup', {
            title: 'Verifying Your Payment with the Bank',
            message:
              "Your order has been placed successfully. We're currently waiting for the payment confirmation from your bank. It can take some time. Thank you for your patience!",
            severity: 'success',
            redirectTo: '/dashboard/mutual-funds/orders',
            goBack: '/dashboard',
          })
          clearInterval(intervalRef.current)
        }

        if (status?.includes('APPROVED')) {
          onOpen('openActionPlanPopup', {
            title: '',
            message:
              'Payment Successful! 🎉 Your Internet-banking transaction has been completed securely. Thank you for your payment!',
            severity: 'success',
            redirectTo: '/dashboard/mutual-funds/orders',
            goBack: '/dashboard',
          })
          clearInterval(intervalRef.current)
        }
      }
    } catch (error) {
      console.error('Payment status error:', error)
    }
  }

  useEffect(() => {
    if (!location?.state) {
      intervalRef.current = setInterval(() => {
        setTimeElapsed((prev) => {
          const updated = prev + 10
          console.log('🚀 ~ setTimeElapsed ~ updated:', updated)
          paymentStatus(updated)

          if (updated >= 300) {
            clearInterval(intervalRef.current)
          }

          return updated
        })
      }, POLL_INTERVAL)

      return () => clearInterval(intervalRef.current)
    }
  }, [])

  useEffect(() => {
    if (location?.state) {
      const container = document.getElementById('bankPage')
      setTimeout(() => {
        const form = container?.querySelector('form[name="Bankfrm"]')
        if (form) {
          form.submit()
        }
      }, 3000)

      return () => {
        if (container?.parentNode) {
          container.parentNode.removeChild(container)
        }
      }
    }
  }, [responseString])

  return (
    <div className='flex justify-center items-center h-screen  bg-white'>
      {!location?.state ? (
        <div>
          <div className='ease-in-out md:max-w-2xl m-auto flex flex-col justify-center px-2'>
            <div className='flex flex-col gap-y-12'>
              {/* <div>
           <img src={`${env.SVGS}/payment.gif`} alt='Payment Gif' className='rounded-xl' />
         </div> */}
              <div className='flex flex-col gap-y-5'>
                <div className='flex flex-col gap-y-3'>
                  <h1 className='text-2xl font-medium text-center'>Processing Your Payment</h1>
                  <p className='text-center text-secondary-700 bg-secondary-50 font-medium rounded-full text-xs leading-3 py-2'>
                    Please wait on the screen for confirmation after payment
                  </p>

                  <Progress value={progress} className='h-2 bg-primary-100' />
                </div>

                <p className='text-center text-sm font-medium text-black-400 '>
                  Please wait while we process your payment. This may take 1-2 minutes.
                  <br />
                  <span className='animate-pulse'>Do not close or go back.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          id='bankPage'
          dangerouslySetInnerHTML={{ __html: responseString }}
          className='fixed top-0 left-0 right-0 bottom-0 z-[1000] bg-white h-screen w-screen'
        />
      )}
    </div>
  )
}

export default ActionPlanPaymentStatus
